import * as React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';


const Newsletter = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-100px" });

    return (
        <section className="newsletter-section">
            <div className="newsletter-container">
                <motion.div 
                    ref={ref}
                    className="newsletter-content"
                    initial={{ opacity: 0, y: 20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.6 }}
                >
                <motion.div 
                    className="newsletter-header"
                    initial={{ opacity: 0, y: 20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <h2 className="newsletter-title">
                        <FontAwesomeIcon icon={faEnvelope} className="newsletter-icon" />
                        Stay up to date
                    </h2>
                   
                </motion.div>
                
                <motion.form
                    method="POST"
                    data-netlify="true"
                    action="/contact/thanks/"
                    className="newsletter-form"
                    initial={{ opacity: 0, y: 20 }}
                    animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                >
                    <input type="hidden" name="form-name" value="newsletter-signup" />
                    <div className="form-group">
                        <div className="input-wrapper">
                            <motion.input
                                className="newsletter-input"
                                type="email"
                                name="email"
                                id="email"
                                required={true}
                                placeholder="Enter your email address"
                                initial={{ opacity: 0, scale: 0.95 }}
                                animate={isInView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }}
                                transition={{ duration: 0.5, delay: 0.6 }}
                            />
                            <button 
                                className="newsletter-button" 
                                type="submit"
                                aria-label="Subscribe to newsletter"
                            >
                                <FontAwesomeIcon icon={faPaperPlane} />
                            </button>
                        </div>

                    </div>
                </motion.form>
                            </motion.div>
            </div>
        </section>
    );
};

export default Newsletter;


